import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { numberRegex } from 'src/app/resources/Constants';

export interface CellManualEditMemoryModal {
  originalValue: string;
  modifyValue: string;
  newValue: string;
}

@Component({
    selector: 'app-cell-manual-edit-memory-modal',
    templateUrl: './cell-manual-edit-memory-modal.component.html',
    styleUrls: ['./cell-manual-edit-memory-modal.component.scss'],
    standalone: false
})
export class CellManualEditMemoryModalComponent implements OnInit {

  @Input() inputValues: CellManualEditMemoryModal;
  @Output() closeModal: EventEmitter<string> = new EventEmitter();
  valid: string;
  regexForNumber = numberRegex;
  formCellManualEdit: UntypedFormGroup;
  submitted = false;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    this.formCellManualEdit = this.formBuilder.group({
      originalValue: [this.inputValues.originalValue],
      modifyValue: [this.inputValues.modifyValue, [Validators.required, Validators.pattern(this.regexForNumber), Validators.min(0)]],
      newValue: [this.inputValues.newValue]
    });

    this.formCellManualEdit.get('modifyValue').valueChanges.subscribe(val => {
      this.getValue(val);
    });
  }

  /**
   * If you do not enter a value, the result is the same as the original,
   * otherwise the entered value is subtracted from the original value
   * @param modifyValue Value to subtract inserted in the input
   */

  getValue(modifyValue: number) {
    // // console.log(this.formCellManualEdit.value.originalValue);
    const valueInNumber = this.formCellManualEdit.value.originalValue? parseFloat(this.formCellManualEdit.value.originalValue.replace(',', '.')) : 0;
    if (!modifyValue) {
      this.formCellManualEdit.patchValue(
        {
          newValue: this.formCellManualEdit.value.originalValue
        }
      );
      return;
    }

    this.formCellManualEdit.patchValue(
      {
        newValue: String(valueInNumber - modifyValue).replace('.', ',')
      }
    );
    // TODO see if insert the control if the entered value is greater than the initial value
  }

  /**
   * Get form
   */

  get form() { return this.formCellManualEdit.controls; }


  /**
   * Modal submit. Send the value of the result, replacing the point with a comma
   * and close modal
   */

  onSubmit() {
    this.submitted = true;

    if (this.formCellManualEdit.invalid) { return; }

    this.closeModal.emit(this.formCellManualEdit.value.newValue.replace('.', ','));
    this.activeModal.close();
  }

}
